module.exports = __webpack_public_path__ + "img/8_Proximal-T.b1329199.png";